import React from 'react';

export const CalendarContainer = ({
  className,
  children,
  showPopperArrow,
  arrowProps = {},
}: {
  className: string;
  children: React.ReactNode;
  showPopperArrow: boolean;
  arrowProps: Record<string, unknown>;
}): JSX.Element => {
  return (
    <div className={className}>
      {showPopperArrow && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <div className="react-datepicker__triangle" {...arrowProps} />
      )}
      {children}
    </div>
  );
};
